module.exports = __webpack_public_path__ + "media/ה.835fc038.mp3";